import React, { useEffect, useMemo } from 'react';
import { useVariant } from '@unleash/proxy-client-react';
import { useDispatch } from 'react-redux';

import { bool, number } from 'prop-types';
import Urls from 'mangools-commons/dist/constants/Urls';
import Timer from 'components/messages/topLevel/Timer';
import { gtmTrack } from 'actions/analyticsActions';

import upgradeImg from 'images/gift.svg';

// Black Friday ends: Dec 10, 2025, 23:59:59 PST (UTC-8)
const BLACK_FRIDAY_END_DATE = new Date('2025-12-11T07:59:59Z'); // Dec 11 07:59:59 UTC = Dec 10 23:59:59 PST

function NewUserMessage(props) {
    const dispatch = useDispatch();
    const variant = useVariant('early-bird-ab-test');
    const isOneTimeVariant = variant.enabled && variant.name === 'onetime-earlybird';
    const isBlackFriday = useMemo(() => new Date() < BLACK_FRIDAY_END_DATE, []);

    useEffect(() => {
        if (!isBlackFriday) {
            dispatch(
                gtmTrack({
                    event: 'unleash',
                    ABTestName: 'earlybird',
                    ABTestVariant: variant.name,
                }),
            );
        }
    }, [isBlackFriday]);

    if (props.visible) {
        if (isBlackFriday) {
            // Black Friday banner
            return (
                <div className="mg-page-message">
                    <div className="uk-container uk-container-center uk-flex uk-flex-middle uk-flex-center">
                        <img
                            src={upgradeImg}
                            alt="Upgrade subscription"
                            width="18"
                            className="mg-margin-r-10"
                            style={{ marginTop: '-3px' }}
                        />
                        <strong>Black Friday is here! Save 35% on SEO tools &amp; up to 50% on our new LLM rank tracker!&nbsp;</strong>
                        <a
                            className="mg-btn is-orange is-gradient is-pill is-xsmall mg-margin-l-15"
                            href={`${Urls.MANGOOLS_PLANS_AND_PRICING_URL}?ref=msg-app-sw`}
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            Grab the deal
                        </a>
                    </div>
                </div>
            );
        } else {
            // Early-bird banner (after Black Friday)
            return (
                <div className="mg-page-message">
                    <div className="uk-container uk-container-center uk-flex uk-flex-middle uk-flex-center">
                        <img
                            src={upgradeImg}
                            alt="Upgrade subscription"
                            width="18"
                            className="mg-margin-r-10"
                            style={{ marginTop: '-3px' }}
                        />
                        <strong>Get 10% {isOneTimeVariant ? '' : 'LIFETIME'} discount&nbsp;</strong> on Mangools SEO
                        tools!&nbsp;
                        <Timer limit={props.timerLimitSeconds} />
                        <span className="uk-hidden-medium mg-margin-l-10">Hurry up, time is running.&nbsp;</span>
                        <a
                            className="mg-btn is-orange is-gradient is-pill is-xsmall mg-margin-l-15"
                            href={`${Urls.MANGOOLS_PLANS_AND_PRICING_URL}?ref=msg-app-sw`}
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            Grab discount
                        </a>
                    </div>
                </div>
            );
        }
    } else {
        return null;
    }
}

NewUserMessage.propTypes = {
    timerLimitSeconds: number.isRequired,
    visible: bool.isRequired,
};

export default NewUserMessage;
